<template>
    <div class="Input InputTextArea">
        <el-input
                :name="'input-' + name"
                v-model="localModel"
                :placeholder="placeholder"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 15}"
                :class="{ error: localErrors.length }"
                v-on:blur="onBlur()"
                v-on:keydown.enter.prevent>
        </el-input>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputTextArea
        position: relative
        .el-textarea
            &.error
              .el-textarea__inner
                  border: 1px solid $color-base
        .el-textarea__inner
            padding: 1rem
            border-color: $color-gray-medium
            font-family: Roboto, sans-serif
            font-size: 14px
            font-weight: 400
            &:focus
                border-color: $color-gray-medium

</style>

<script>

    export default {
        props: ["name", "value", "items", "placeholder", "errors"],
        data() {
            return {
                localModel: this.value,
                localErrors: this.errors || []
            }
        },
        watch: {
            localModel(val) {
                this.$emit("input", val);
            },
            value: function(newVal, oldVal) {
                this.localModel = newVal;
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        },
        methods: {
            onBlur: function() {
                this.$parent.validate();
            },
            onKeyup: function(e) {
                console.log(e.keyCode);
                if (e.keyCode == 13) { // prevent submit by enter keypress
                  e.preventDefault();
                }
            }
        }
    }

</script>
